import {
  BulkStatus,
  IBulkPayrollBatch,
  IBulkPayrollItem
} from "@wingspanhq/payments/dist/interfaces";
import { WSService } from "../utils/WSService";

const service = new WSService("/payments/bulk/payroll/batch");

export type ApiQueryListBulkPayrollBatches = {
  "filter[status][=]"?: BulkStatus;
  "filter[status][in]"?: BulkStatus[];
};

export async function listBulkPayrollBatches(
  query?: ApiQueryListBulkPayrollBatches
): Promise<IBulkPayrollBatch[]> {
  const { data } = await service.get("", { params: query });
  return data;
}

export async function getBulkPayrollBatch(
  batchId: string
): Promise<IBulkPayrollBatch> {
  const { data } = await service.get("/" + batchId);
  return data;
}

export async function listBulkPayrollBatchItems(
  batchId: string
): Promise<IBulkPayrollItem[]> {
  const { data } = await service.get("/" + batchId + "/item");
  return data;
}

export async function getBulkPayrollBatchItem(
  batchId: string,
  batchItemId: string
): Promise<IBulkPayrollItem> {
  const { data } = await service.get("/" + batchId + "/item" + batchItemId);
  return data;
}
